import { BreakpointObserver } from '@angular/cdk/layout';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, contentChildren, inject, input, TemplateRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map } from 'rxjs';

@Component({
	selector: 'ui-grid',
	imports: [NgTemplateOutlet],
	templateUrl: './grid.component.html',
	host: {
		class: '-mx-3 pt-3 -mt-3',
	},
})
export class GridComponent {
	private readonly breakpointObserver = inject(BreakpointObserver);

	columns = input<number>(2);
	mobileBreakpoint = input<string, number>('(min-width: 1280px)', {
		transform: (v: number) => `(min-width: ${v}px)`,
	});

	items = contentChildren('gridItem', {
		read: TemplateRef,
	});

	sortedItems = computed(() => {
		const cols = this.isDesktop() ? this.columns() : 1;
		return [...Array(cols).keys()].map((i) =>
			this.items().filter((_, index) => index % cols === i)
		);
	});

	styleClasses = computed(() => {
		const classes = ['grid', 'print:grid-cols-1!', 'gap-6', 'px-3', 'pt-3', '-mt-3'];

		if (this.isDesktop()) {
			classes.push(`grid-cols-${this.columns()}`);
		} else {
			classes.push('grid-cols-1');
		}

		return classes.join(' ');
	});

	isDesktop = toSignal(
		this.breakpointObserver.observe(this.mobileBreakpoint()).pipe(
			map((result) => result.matches),
			distinctUntilChanged()
		),
		{
			initialValue: this.breakpointObserver.isMatched(this.mobileBreakpoint()),
		}
	);
}
